import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FETCH_RECEIPTS_CSV_REPORT_V2, showMessage } from '~/actions';
import { Column, ConfirmPopup, Label, Text } from '~/commonComponents';
import InputSelect from '~/commonComponents/InputSelect';
import { paymentHistoryFilterOptionsLabels } from '~/constants';
import { useIsSuccess } from '~/hooks';
import { Colors } from '~/themes/colors';
import { ReceiptTransactionDateEnum } from '~/utils/Enum';
import { useDownloadReportV2 } from './hooks';

interface IProps {
  onClosePopup: () => void;
}

export const DownloadReportPopup = ({ onClosePopup }: IProps) => {
  const dispatch = useDispatch();

  const [formDateRange, setFormDateRange] = useState<string>('');

  const { isLoading, onDownloadReport } = useDownloadReportV2();
  const { isSuccess, clearSuccess } = useIsSuccess([FETCH_RECEIPTS_CSV_REPORT_V2]);

  useEffect(() => {
    if (!isSuccess) return;

    dispatch(
      showMessage({
        popupProps: {
          rightButtonAction: () => {
            onClosePopup();
            clearSuccess();
          },
          rightButtonText: 'Done',
        },
        title: 'Report Downloaded Successfully!',
        message:
          'Your transaction report was downloaded successfully. If you need further assistance, please text us at (786) 460-2170.',
        isSuccess: true,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  if (isSuccess) {
    return null;
  }

  return (
    // @ts-expect-error ConfirmPopup component still written in JavaScript
    <ConfirmPopup
      title="Download Report"
      titleStyle={{
        fontSize: 18,
      }}
      leftButtonAction={onClosePopup}
      leftButtonDisabled={isLoading}
      leftButtonText="Close"
      rightButtonAction={() => onDownloadReport(formDateRange as ReceiptTransactionDateEnum)}
      rightButtonDisabled={isLoading || !formDateRange}
      rightButtonLoading={isLoading}
      rightButtonText="Download"
    >
      <Column alignItems="center">
        <Text textAlign="center" color={Colors.neutral_500}>
          Before proceeding with the download, please select a<br />
          transaction date range from the dropdown below.
        </Text>

        <Column marginTop={32} marginBottom={38} width={385}>
          <Label text="Transaction Date Range:" required />
          {/* @ts-expect-error -- InputSelect still written in JavaScript */}
          <InputSelect
            value={formDateRange}
            setValue={setFormDateRange}
            isSelectVisible={false}
            options={
              Object.entries(paymentHistoryFilterOptionsLabels).map(([key, name]) => ({
                value: key,
                title: name,
              })) as any
            }
          />
        </Column>
      </Column>
    </ConfirmPopup>
  );
};
